__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/1bae696/_next/";